/* PW A11Y PASS 3 (v32, 28 Sep 2026). Loaded site wide from sections/pw-peek.liquid. See pw-a11y-3.css. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PAUSE = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><rect x="1" y="0" width="3" height="12" fill="currentColor"/><rect x="8" y="0" width="3" height="12" fill="currentColor"/></svg>';
  var PLAY = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 0L11 6L2 12Z" fill="currentColor"/></svg>';

  function marquees() {
    document.querySelectorAll('.pw-marquee').forEach(function (m) {
      if (m.querySelector('.pw-marquee__pause')) return;
      /* the band may be aria-hidden; the button must stay reachable, so move the hidden flag onto the track */
      if (m.getAttribute('aria-hidden') === 'true') {
        m.removeAttribute('aria-hidden');
        var tr = m.querySelector('.pw-marquee__track'); if (tr) tr.setAttribute('aria-hidden', 'true');
      }
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pw-marquee__pause';
      function set(p) {
        m.classList.toggle('pw-marquee--paused', p);
        b.setAttribute('aria-pressed', p ? 'true' : 'false');
        b.setAttribute('aria-label', p ? 'Play scrolling text' : 'Pause scrolling text');
        b.innerHTML = p ? PLAY : PAUSE;
      }
      b.addEventListener('click', function () { set(!m.classList.contains('pw-marquee--paused')); });
      set(RM);
      m.appendChild(b);
    });
  }

  function dogs() {
    var root = document.getElementById('pw-cast');
    if (!root || root.querySelector('.pw-hide-dogs')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'pw-hide-dogs'; b.textContent = 'Hide the dogs';
    b.addEventListener('click', function () {
      try { sessionStorage.setItem('pw-peek-off', '1'); } catch (e) {}
      root.classList.add('pw-cast--off');
      setTimeout(function () { if (root.parentNode) root.remove(); }, 50);
    });
    root.appendChild(b);
  }

  function boot() { marquees(); dogs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
